import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { SlideTabs } from './ui/slide-tabs';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleBookCall = () => {
    const subject = encodeURIComponent('Solicitud de llamada gratuita - FluenceIA');
    const body = encodeURIComponent(`Hola Emilio,

Me gustaría reservar una llamada gratuita de 30 minutos para conocer cómo puedes ayudarme a automatizar mi negocio con IA.

Mis datos:
- Nombre: 
- Tipo de negocio: 
- Teléfono: 

Horarios que me vienen bien:
- Opción 1: 
- Opción 2: 
- Opción 3: 

Gracias,
`);
    window.location.href = `mailto:esaezye@gmail.com?subject=${subject}&body=${body}`;
    setIsMobileMenuOpen(false);
  };

  const tabs = [
  { id: 'inicio', label: 'Inicio' },
  { id: 'servicios', label: 'Servicios' },
  { id: 'sobre-mi', label: 'Sobre mí' },
  { id: 'contacto', label: 'Contacto' }];


  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ?
      'bg-[#013139]/95 backdrop-blur-md shadow-lg' :
      'bg-transparent'}`
      }>

      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-24 md:h-28 !shadow-lg">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('inicio')}>
            <img
              src="https://customer-assets.emergentagent.com/job_negocio-rapido-2/artifacts/pdnfkao1_LOGO%20MONOCROMA%20CLARO.png"
              alt="FluenceIA"
              className="h-16 md:h-28 w-auto"
              style={{ filter: 'drop-shadow(0 0 15px rgba(0,229,163,0.4)) drop-shadow(0 4px 8px rgba(0,0,0,0.3))' }}
            />
          </div>

          {/* Desktop Navigation with SlideTabs */}
          <div className="hidden md:flex items-center gap-6">
            <SlideTabs tabs={tabs} onTabClick={scrollToSection} />
            
            <Button
              onClick={handleBookCall}
              className="bg-[#00E5A3] hover:bg-[#00C497] text-[#013139] font-semibold shadow-lg shadow-[#00E5A3]/20">

              Reserva tu llamada gratuita
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>

            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen &&
        <nav className="md:hidden py-6 bg-[#013139]/95 backdrop-blur-md border-t border-white/10">
            <div className="flex flex-col space-y-4">
              {tabs.map((tab) =>
            <button
              key={tab.id}
              onClick={() => scrollToSection(tab.id)}
              className="text-white hover:text-[#00E5A3] transition-colors font-medium text-left px-4 py-2">

                  {tab.label}
                </button>
            )}
              <Button
              onClick={handleBookCall}
              className="bg-[#00E5A3] hover:bg-[#00C497] text-[#013139] font-semibold w-full mx-4">

                Reserva tu llamada gratuita
              </Button>
            </div>
          </nav>
        }
      </div>
    </header>);

};

export default Header;